// import React, { useEffect, useState } from "react";
// import { Button, Typography } from "@mui/material";
// import { signInwithGoogle } from "./firebase";
// import { Box } from "@mui/system";
// import GoogleIcon from "@mui/icons-material/Google";
// import logo from './components/devangles-logo-150.png'
// import { jwtDecode } from "jwt-decode";

// function Login({ handleLoginFormSubmit }) {
//   const [isSigningIn, setIsSigningIn] = useState(false);

//   const handleGoogleSignIn = () => {
//     if (isSigningIn) {
//       return;
//     }
//     setIsSigningIn(true);

//     signInwithGoogle()
//       .then(() => {
//         handleLoginFormSubmit(); // call the handleLoginFormSubmit function passed as a prop from App component
//       })
//       .catch((error) => {
//         alert(error.message); // Show an error message if the sign-in is unsuccessful
//       })
//       .finally(() => {
//         setIsSigningIn(false);
//       });
//   };

      






//   // async function checkIsAdmin(emailId) {
//   //   const url = "http://localhost:5000/check-is-admin"; // API URL
//   //   const requestBody = { email_id: emailId };
  
//   //   try {
//   //     const response = await fetch(url, {
//   //       method: "POST",
//   //       headers: { "Content-Type": "application/json" },
//   //       body: JSON.stringify(requestBody),
//   //     });
  
//   //     const data = await response.json();
  
//   //     if (!response.ok) {
//   //       if (data.error === "User not allowed") {
//   //         alert("Please contact admin, you are not authorized.");
//   //         throw new Error("User not allowed"); // Stop execution
//   //       }
//   //       throw new Error(data.error || "Unknown API error");
//   //     }
  
//   //     // **Extract JWT Token**
//   //     const token = data.token;
//   //     if (!token) {
//   //       throw new Error("No token received from API");
//   //     }
  
//   //     //  **Store Token Securely**
//   //     sessionStorage.setItem("authToken", token);
//   //     console.log(token)
  
//   //     // **Decode JWT Token**
//   //     const decoded = jwtDecode(token);
//   //     console.log("Decoded Token:", decoded);
  
//   //     return decoded; // { email, isAdmin, exp }
//   //   } catch (error) {
//   //     console.error("Request failed:", error);
//   //     throw error; // Ensure the error propagates
//   //   }
//   // }

//   // useEffect(() => {
//   //   checkIsAdmin("nayan@devangles.com")
//   // }, []);
  



//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         justifyContent: "center",
//         boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
//         p: 3,
//         borderRadius: 4,
//         maxWidth: 500,
//         mx: "auto",
//         mt: 20,
//         backgroundColor: "#F0F0F",
//       }}
//     >
//       <img src={logo} alt="DevAngles" style={{ width: 300, height: 50, marginBottom: 20 }} />
//       <Typography style={{ color: "#2E2E2E" }}>Welcome Back!</Typography>
//       <Button
//         onClick={handleGoogleSignIn}
//         variant="contained"
//         startIcon={<GoogleIcon />}
//         sx={{ mt: 3, backgroundColor: "#4285F4", color: "#FFFFFF" }}
//         disabled={isSigningIn}
//       >
//         {isSigningIn ? 'Signing in...' : 'Log In with Google'}
//       </Button>
//     </Box>
//   );
// }
// export default Login;




import React from 'react';
import { Box, Button, Typography  } from '@mui/material';
import logo from './components/devangles-logo-150.png';
import googleLogo from './components/google.png';

const Login = ({ handleLoginFormSubmit }) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const handleClick = async () => {
    if (isLoading) return; // Prevent multiple clicks
    setIsLoading(true);
    try {
      await handleLoginFormSubmit();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box 
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            p: 3,
            borderRadius: 4,
            maxWidth: 500,
            mx: "auto",
            mt: 20,
            backgroundColor: "#F0F0F",
          }}>
          <img src={logo} alt="DevAngles" style={{ width: 300, height: 50, marginBottom: 20 }} />
            <Typography
            variant="h6"
            sx={{ mb: 3, fontSize: "18px", fontWeight: 400 }}
          >
            Welcome to DevAngles EMS
          </Typography>
      <Button
        variant="outlined"
        onClick={handleClick}
        disabled={isLoading}
        sx={{
          backgroundColor: "#fff",
          color: "#000",
          border: "1px solid #ccc",
          textTransform: "none",
          fontSize: "16px",
          fontWeight: 500,
          padding: "8px 24px",
          borderRadius: "8px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          "&:hover": {
            backgroundColor: "#f7f7f7",
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
          },
        }}
      >
        <img
          src={googleLogo}
          alt="Google logo"
          style={{ width: 20, height: 20 }}
        />
        {isLoading ? 'Signing in...' : 'Continue With Google'}
      </Button>
    </Box>
  );
};

export default Login;